{
  "plan_details": {
    "frequency": {
      "annually": "Annuellement",
      "monthly": "Mensuel",
      "title": "Payez chaque année et économisez 10 %"
    },
    "choose_currency": "Choisissez votre devise",
    "includes": "Ce qui est inclus :",
    "everything_in": "Tout dans {{ plan }} plus :",
    "per_user": "par utilisateur/par mois",
    "switch_to": "Passez à {{ plan }}",
    "upgrade_to": "Passez à {{ plan }}",
    "manage_plan": "Gérer le plan",
    "call_us": "Appelez-nous",
    "contact_us": "Nous contacter",
    "title": {
      "part_1": "Choisissez le plan idéal pour vous et votre",
      "part_2": "L'équipe"
    },
    "subtitle": {
      "part_1": "Comparez nos forfaits et fonctionnalités sur notre",
      "part_2": "page de tarification",
      "part_3": "ou"
    },
    "plans": {
      "professional": {
        "name": "professionnel",
        "prev_plan": "",
        "features": {
          "1": "Plans illimités pour votre événement",
          "2": "Accès à une bibliothèque complète de modèles de couches",
          "3": "Des modèles 3D pour visualiser les plans avec précision",
          "4": "Attributs permettant de saisir les données, y compris les dates et les coûts",
          "5": "Espace de travail partagé pour votre équipe",
          "6": "Calques et icônes personnalisables et flexibles",
          "7": "Outils d'analyse, y compris un calculateur de capacité de foule",
          "8": "Exportations professionnelles au format PDF",
          "9": "Intégration CAO et mises à jour illimitées",
          "10": "Assistance à l'intégration",
          "11": "Nombre de spectateurs illimité !"
        }
      },
      "premium": {
        "name": "prime",
        "prev_plan": "professionnel",
        "features": {
          "1": "Capturez et visualisez les plans par heure et date",
          "2": "Outils de collaboration, y compris commentaires, balises, fils de discussion",
          "3": "Combinez les plans de différents utilisateurs et équipes",
          "4": "Analysez les quantités et les coûts de votre projet",
          "5": "Exportation de données géospatiales au format SIG",
          "6": "Service d'importation de fichiers CAO",
          "7": "Assistance à l'intégration sur mesure",
          "8": "Nombre de spectateurs illimité !"
        }
      },
      "enterprise": {
        "name": "entreprise",
        "prev_plan": "prime",
        "features": {
          "1": "Intégration et gestion de compte sur mesure",
          "2": "Visualisez les forfaits à l'aide de graphismes de qualité gaming",
          "3": "Planifiez à l'aide de cartes de ville 3D de Google",
          "4": "Publiez des cartes personnalisées en ligne",
          "5": "Assistance d'experts pour créer des modèles, des icônes et des modèles 3D",
          "6": "SSO pour plus de sécurité",
          "7": "Assistance 24 h/24 et 7"
        }
      }
    }
  }
}